import CustomImage from "../../../core/CustomImage/CustomImage";
import classes from "../Banner.module.scss";

const VideoBanner = ({ image, title, subText, hours }) => {
  const style = {
    container: {
      display: "flex",
      flexDirection: "column",
      gap: 10,
    },
  };
  return (
    <div style={style.container}>
      <CustomImage src={image} alt={title} title={title} width="100%" />
      <div className={classes.videoheading}>{title}</div>
      <div className={classes.videosubtext}>
        <span>{subText}</span> • <span>{hours}</span>
      </div>
    </div>
  );
};
export default VideoBanner;
